import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { toast } from "sonner";
import AxiosInstance from "@/utils/AxiosInstance";

interface GlucoseMeterFlowProps {
  isOpen: boolean;
  onComplete: () => void;
  alert?: any;
}

const GlucoseMeterFlow = ({ isOpen, onComplete, alert }: GlucoseMeterFlowProps) => {
  const navigate = useNavigate();
  const [triageDetails, setTriageDetails] = useState("");
  const [showNursingNoteDialog, setShowNursingNoteDialog] = useState(false);
  const [showOkDialog, setShowOkDialog] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  if (!isOpen) return null;

  const handleSave = async () => {
    if (!triageDetails.trim()) {
      toast.error("Please enter triage details before saving");
      return;
    }

    const patientId = alert?.patientId?._id || alert?.patientId;
    const alertId = alert?._id;
    const triageData = {
      alertId: alertId,
      patientId: patientId,
      deviceType: "glucose_meter",
      triageDetails: triageDetails.trim(),
      timestamp: new Date().toISOString(),
    };

    try {
      setBtnLoading(true);
      const { data }: any = await AxiosInstance().post(
        `/triage-forms/glucose-meter`,
        { ...triageData },
      );
      if (data.success) {
        // setShowNursingNoteDialog(true);
        onComplete();
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to save triage details");
    } finally {
      setBtnLoading(false);
    }
  };

  // const handleNursingNoteResponse = (response: "yes" | "no") => {
  //   setShowNursingNoteDialog(false);

  //   if (response === "yes") {
  //     // Navigate to patient profile
  //     const patientId = alert?.patientId?._id || alert?.patientId;
  //     if (patientId) {
  //       navigate(`/patients/${patientId}?tab=nursing-notes`);
  //     } else {
  //       // Fallback to alerts if patient ID not found
  //       navigate("/alerts");
  //     }
  //   } else {
  //     navigate("/alerts");
  //   }
  // };

  // const handleOkClick = () => {
  //   setShowOkDialog(false);
  //   navigate("/alerts");
  // };

  // Handle Enter key for Save button
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Enter" && !showNursingNoteDialog && !showOkDialog && !btnLoading) {
        const target = e.target as HTMLElement;
        // Don't trigger if user is typing in textarea
        if (target.tagName !== "TEXTAREA") {
          e.preventDefault();
          if (triageDetails.trim()) {
            handleSave();
          }
        }
      }
    };

    if (isOpen && !showNursingNoteDialog && !showOkDialog) {
      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    }
  }, [isOpen, showNursingNoteDialog, showOkDialog, btnLoading, triageDetails]);

  // Handle Enter key for Nursing Note dialog buttons
  // useEffect(() => {
  //   const handleKeyDown = (e: KeyboardEvent) => {
  //     if (e.key === "Enter" && showNursingNoteDialog && !e.shiftKey) {
  //       e.preventDefault();
  //       // Default to "Yes" when Enter is pressed
  //       handleNursingNoteResponse("yes");
  //     }
  //   };

  //   if (showNursingNoteDialog) {
  //     window.addEventListener("keydown", handleKeyDown);
  //     return () => window.removeEventListener("keydown", handleKeyDown);
  //   }
  // }, [showNursingNoteDialog]);

  // Handle Enter key for OK dialog button
  // useEffect(() => {
  //   const handleKeyDown = (e: KeyboardEvent) => {
  //     if (e.key === "Enter" && showOkDialog && !e.shiftKey) {
  //       e.preventDefault();
  //       handleOkClick();
  //     }
  //   };

  //   if (showOkDialog) {
  //     window.addEventListener("keydown", handleKeyDown);
  //     return () => window.removeEventListener("keydown", handleKeyDown);
  //   }
  // }, [showOkDialog]);

  return (
    <>
      <div className="space-y-6 mt-6">
        <Card>
          <CardHeader>
            <CardTitle>Please enter the details of the Glucose Monitor Triage.</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="triage-details">Triage Details</Label>
                <Textarea
                  id="triage-details"
                  placeholder="Enter triage details..."
                  value={triageDetails}
                  onChange={(e) => setTriageDetails(e.target.value)}
                  rows={6}
                  className="resize-none"
                />
              </div>
              <div className="flex justify-end gap-3 pt-4">
                <Button variant="outline" onClick={() => navigate("/alerts")}>
                  Cancel
                </Button>
                <Button
                  onClick={handleSave}
                  className="bg-amber-600 hover:bg-amber-700 text-white"
                  disabled={btnLoading}
                >
                  {btnLoading ? "Saving..." : "Save"}
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Nursing Note Alert Dialog */}
      {/* <Dialog open={showNursingNoteDialog} onOpenChange={setShowNursingNoteDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Alert</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <p className="text-sm">
              You have now completed your triage assessment. would you like to enter nursing note for this?
            </p>
            <div className="flex justify-end gap-3 pt-4">
              <Button
                variant="outline"
                onClick={() => handleNursingNoteResponse("no")}
                className="border-red-500 text-red-500 hover:bg-red-50"
              >
                No
              </Button>
              <Button
                onClick={() => handleNursingNoteResponse("yes")}
                className="bg-amber-600 hover:bg-amber-700 text-white"
              >
                Yes
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog> */}

    </>
  );
};

export default GlucoseMeterFlow;

